import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'

// Styles
import classes from './AdminPromocode.scss'

// Actions
import { promocodeActions } from 'redux/actionCreators'

// Components
import { FormGroup, Loader } from 'components'
import Select from 'react-select'
import 'react-select/dist/react-select.css'

import { get, isEqual } from 'lodash'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

const mapStateToProps = (state, ownProps) => ({
  promocode: get(state, 'promocode.promocode'),
  saving: get(state, 'promocode.saveAttempting'),
  adding: get(state, 'promocode.addAttempting'),
  added: get(state, 'promocode.addAttempted')
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  attemptFindOnePromocode: () =>
    dispatch(promocodeActions.attemptFindOnePromocode({ promocode: ownProps.params.promocode })),
  attemptAddPromocode: (payload) =>
    dispatch(promocodeActions.attemptAddPromocode(payload)),
  attemptSavePromocode: (payload) =>
    dispatch(promocodeActions.attemptSavePromocode({
      promocode: ownProps.params.promocode,
      ...payload
    }))
})

@connect(mapStateToProps, mapDispatchToProps)
class AdminPromocode extends Component {
  static contextTypes = { router: PropTypes.object.isRequired };
  constructor (props) {
    super(props)
    this.state = {
      unit: 'percent',
      userType: 'all',
      status: 'active'
    }
  }

  componentWillMount () {
    this.props.attemptFindOnePromocode()
  }

  componentWillReceiveProps (nextProps) {
    if (!isEqual(this.props.promocode, nextProps.promocode)) {
      this.setState({
        discount: get(nextProps, 'promocode.discount'),
        quota: get(nextProps, 'promocode.quota'),
        minimumSpend: get(nextProps, 'promocode.minimumSpend'),
        unit: get(nextProps, 'promocode.unit'),
        userType: get(nextProps, 'promocode.userType') || 'all',
        status: get(nextProps, 'promocode.status'),
        validFrom: get(nextProps, 'promocode.validFrom')
          ? moment(get(nextProps, 'promocode.validFrom'), 'YYYY-MM-DD')
          : null,
        validUntil: get(nextProps, 'promocode.validUntil')
          ? moment(get(nextProps, 'promocode.validUntil'), 'YYYY-MM-DD')
          : null
      })
    }
  }

  _onDateChange = (field, date) => {
    this.setState({ [field]: date })
  };

  _onSave = () => {
    const { attemptAddPromocode, attemptSavePromocode, promocode } = this.props
    const payload = {
      discount: this.state.discount,
      quota: this.state.quota,
      minimumSpend: this.state.minimumSpend,
      unit: this.state.unit,
      status: this.state.status || 'inactive',
      userType: this.state.userType || 'all',
      validFrom: this.state.validFrom
        ? this.state.validFrom.format('YYYY-MM-DD')
        : null,
      validUntil: this.state.validUntil
        ? this.state.validUntil.format('YYYY-MM-DD')
        : null
    }
    if (!get(promocode, 'code')) {
      attemptAddPromocode({
        code: this.state.code,
        ...payload
      })
    } else {
      attemptSavePromocode(payload)
    }
  }

  render () {
    const { promocode, saving } = this.props

    return (
      <section className={classes.promocode}>
        <div className={classes.header}>
          <span>{get(promocode, 'code') ? `แก้ไข PROMOCODE: ${promocode.code}` : 'เพิ่ม PROMOCODE'}</span>
        </div>
        {!get(promocode, 'code') &&
          <div>
            <FormGroup title='PROMOCODE'>
              <input className={classes.input} type='text'
                value={this.state.code}
                onChange={e => this.setState({ code: e.target.value.toUpperCase() })} />
            </FormGroup>
          </div>
        }
        <div>
          <div className={classes.inputContainer}>
            <FormGroup title='ส่วนลด'>
              <input className={classes.input} type='text'
                value={this.state.discount}
                onChange={e => {
                  const value = e.target.value
                  if (value && isNaN(value)) return
                  this.setState({ discount: value })
                }} />
            </FormGroup>
          </div>
          <div className={classes.inputContainer}>
            <FormGroup title='หน่วย'>
              <div className='margin-vertical-10'>
                <Select name='company' value={this.state.unit}
                  clearable={false} placeholder='กรุณาเลือกหน่วยของส่วนลด'
                  options={[
                    { value: 'percent', label: '%' },
                    { value: 'baht', label: 'บาท' }
                  ]}
                  onChange={({ value }) => this.setState({ unit: value })} />
              </div>
            </FormGroup>
          </div>
          <div className={classes.inputContainer}>
            <FormGroup title='จำนวนครั้งที่ใช้ได้'>
              <input className={classes.input} type='text'
                value={this.state.quota}
                onChange={e => {
                  const value = e.target.value
                  if (value && isNaN(value)) return
                  this.setState({ quota: value })
                }} />
            </FormGroup>
          </div>
          <div className={classes.inputContainer}>
            <FormGroup title='ราคาขั้นต่ำที่ใช้ได้'>
              <input className={classes.input} type='text'
                value={this.state.minimumSpend}
                onChange={e => {
                  const value = e.target.value
                  if (value && isNaN(value)) return
                  this.setState({ minimumSpend: value })
                }} />
            </FormGroup>
          </div>
        </div>
        <div>
          <div className={classes.inputContainer}>
            <FormGroup title='ประเภทลูกค้าที่ใช้ได้'>
              <div className='margin-vertical-10'>
                <Select value={this.state.userType}
                  clearable={false}
                  options={[
                    { value: 'all', label: 'ทั้งหมด' },
                    { value: 'retail', label: 'ลูกค้าปลีก' },
                    { value: 'wholesale', label: 'ลูกค้าส่ง' },
                    { value: 'pharmacy', label: 'เฉพาะร้านยา' },
                    { value: 'non-pharmacy', label: 'ไม่ใช่ร้านยา' }
                  ]}
                  onChange={({ value }) => this.setState({ userType: value })} />
              </div>
            </FormGroup>
          </div>
          <div className={classes.inputContainer}>
            <FormGroup title='วันที่เริ่มต้น'>
              <DatePicker dateFormat='DD-MM-YYYY' selected={this.state.validFrom} onChange={(date) => this._onDateChange('validFrom', date)} />
            </FormGroup>
          </div>
          <div className={classes.inputContainer}>
            <FormGroup title='วันที่สิ้นสุด'>
              <DatePicker dateFormat='DD-MM-YYYY' selected={this.state.validUntil} onChange={(date) => this._onDateChange('validUntil', date)} />
            </FormGroup>
          </div>
          {get(promocode, 'code') &&
            <div className={classes.inputContainer}>
              <FormGroup title='สถานะการใช้งาน'>
                <div className='margin-vertical-10'>
                  <Select value={this.state.status}
                    clearable={false}
                    options={[
                      { value: 'active', label: 'ใช้งาน' },
                      { value: 'inactive', label: 'ไม่ใช้งาน' }
                    ]}
                    onChange={({ value }) => this.setState({ status: value })} />
                </div>
              </FormGroup>
            </div>
          }
        </div>
        <div className={classes.buttonContainer}>
          <div className={`btn ${classes.btn}`} onClick={this._onSave}>
            {saving ? <Loader /> : <span>บันทึก</span>}
          </div>
        </div>
      </section>
    )
  }
}

export default AdminPromocode



/** WEBPACK FOOTER **
 ** ./src/containers/Admin/AdminPromocode/AdminPromocode.js
 **/